<ng-container>
    <app-top-tabs></app-top-tabs>

    @if(messages != null){
    @if(messages.length > 0){
    <div ngbAccordion class="messages-accordion mt-5">
        @for (message of messages; track message) {
        <div ngbAccordionItem [collapsed]="!$first" (shown)="onItemShown(message.uuid)">
            <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="bg-white py-2 shadow-none">
                    <app-small-message-tile [message]="message"></app-small-message-tile>
                </button>
            </h2>
            <div ngbAccordionCollapse>
                <div ngbAccordionBody class="bg-white pt-0">
                    <ng-template>
                        <p>
                            {{message.text}}
                        </p>
                        <div class="my-3">
                            <app-smart-link [message]="message"></app-smart-link>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        }
    </div>
    }@else{
    <div class="text-center mt-3">
        <img src="assets/icons/no-messages-icon.svg" alt="Welcome" width="60" [ngClass]="{ 'placeholder': !hasMessages }" class="mb-3">
        <h5 [ngClass]="{ 'placeholder': !hasMessages }">{{ 'si_pts_chrome_messages_empty_header' | cmsText | async }}</h5>
        <p [appParagraph]="3" [ngClass]="{ 'placeholder': !hasMessages }">{{ 'si_pts_chrome_messages_empty_text' | cmsText | async }}</p>
    </div>
    }
    }

</ng-container>
